var alertTriggersList = {
	caption: "Lista de Triggers de Alertas",
	noResultsMessage: "No se encontraron resultados",
	actions: "Acciones",
	trigger: {
		dateTime: "Fecha de creación",
		limits: "Límites",
		limitAbove: "Límite superior",
		limitBelow: "Límite inferior"
	},
	security: {
		name: "Nombre",
		isin: "ISIN",
		lastPrice: "Precio final",
		lastPriceDateTime: "Fecha/Hora",
		assetClass: "Clase de activo",
		exchange: "Mercado"
	}
};
var es = {
	alertTriggersList: alertTriggersList
};

export { alertTriggersList, es as default };
